import { createContext, Dispatch, SetStateAction } from "react";
import { Palette_Mode } from "../utils/theme";
import { AlertProps } from "@mui/material";

type User = any;

export interface IFeedback {
    loading: boolean;
    show: boolean;
    message: { title: string; body?: string };
    severity: AlertProps["severity"];
}

interface IGlobal_CTX {
    feedback: IFeedback;
    set_feedback: Dispatch<SetStateAction<IFeedback>>;

    palette_mode: Palette_Mode;
    set_palette_mode: Dispatch<SetStateAction<Palette_Mode>>;

    permissions: string[];
    set_permissions: Dispatch<SetStateAction<string[]>>;

    offline: boolean;
    set_offline: Dispatch<SetStateAction<boolean>>;

    refetch_counter: number;
    set_refetch_counter: Dispatch<SetStateAction<number>>;
}

export const Global_CTX = createContext({} as IGlobal_CTX);
